var AccordionTabStyle = {};

export { AccordionTabStyle as default };
